/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import styled from '@emotion/styled'
import DatePickerComponent from 'src/components/DatePicker'
import KeyAccountImg from 'src/static/statistics/ic-key-account.png'
import LocationImg from 'src/static/statistics/ic-location.png'
import BagImg from 'src/static/statistics/ic-bag.png'
import ActivityImg from 'src/static/statistics/ic-activity.png'
import LikeImg from 'src/static/statistics/ic-like.png'
import MapImg from 'src/static/statistics/ic-map.png'
import BlockCarousel from 'src/interview/components/BlockCarousel'
import * as Constants from 'src/interview/landingConstants'
import icQuote from 'src/static/ic-quote-yellow.png'
import ChartComponent from './ChartComponent'

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

const RowContainer = styled.div<{ top?: number; bottom?: number; stretch?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: ${({ top }) => top ?? 0}px;
  margin-bottom: ${({ bottom }) => bottom ?? 0}px;
  justify-content: ${({ stretch }) => (stretch ? 'space-between' : 'unset')};
`
const FilterLabel = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  margin-right: 24px;
  color: #3b424f;
`

const DatePickerWrapper = styled.div`
  width: 300px;
  margin-bottom: -20px;
  margin-right: 12px;
  > div {
    > div {
      > div {
        > div {
          width: 100%;
        }
      }
    }
  }
`

const BlockTitle = styled.div`
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #222b45;
`

const BlockTitleIconContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background: #737991;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
`

const BlockTitleIcon = styled.img<{ size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  object-fit: contain;
`

const ContentBlockContainer = styled.div<{
  height: number
  widthPct?: number
  centered?: boolean
}>`
  border: 1px solid #e1e3ea;
  border-radius: 20px;
  width: ${({ widthPct }) => widthPct ?? 100}%;
  height: ${({ height }) => height ?? 'auto'}px;
  display: flex;
  align-items: center;
  justify-content: ${({ centered }) => (centered ? 'center' : 'unset')};
`

const CompletedSessionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto auto;
  align-items: center;
`

const CompletedSessionsChartContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-evenly;
  width: 100%;
`

const CompletedSessionsValue = styled.div`
  font-weight: 700;
  font-size: 56px;
  line-height: 66px;
  color: #b202ff;
  margin-top: 25px;
`

const MapContainer = styled.div`
  position: relative;
  width: 585px;
  height: 314px;
  background: url(${MapImg});
  background-size: 100% 100%;
`

const MapBadge = styled.div<{ top?: number; left?: number; arrowLeft?: number }>`
  position: absolute;
  height: 58px;
  padding: 14px 25px;
  top: ${({ top }) => top ?? 0}px;
  left: ${({ left }) => left ?? 0}px;
  border: 1px solid #b202ff;
  border-radius: 10px;
  background: white;
  display: flex;
  align-items: center;

  &:after {
    content: '';
    width: 7px;
    height: 7px;
    background: white;
    border-left: 1px solid #b202ff;
    border-top: 1px solid #b202ff;
    position: absolute;
    top: -4px;
    left: ${({ arrowLeft }) => arrowLeft ?? 0}px;
    transform: rotate(45deg);
  }
`

const MapText = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #222b45;
  float: left;
  margin-right: 4px;
`

const MapValue = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 19px;
  color: #b202ff;
  float: left;
`

const CompaniesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

const CompanyItemContainer = styled.div<{ count: number }>`
  position: relative;
  background: #ffffff;
  border: 1px solid #e1e3ea;
  border-radius: 12px;
  margin-right: 23px;
  margin-left: 20px;
  margin-bottom: 20px;
  padding: 23px 30px;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #3b424f;

  &:after {
    position: absolute;
    content: '${({ count }) => count}';
    width: 40px;
    height: 40px;
    background: #b202ff;
    border-radius: 20px;
    font-weight: 500;
    font-size: 16px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 10px;
    left: -20px;
  }
`

const ReviewsBlock = styled.div`
  width: calc(100vw - 550px);
  margin: 0 auto;
  overflow-x: hidden;
  margin-bottom: 40px;

  @media screen and (max-width: 1440px) {
    width: calc(100vw - 470px);
  }
  @media screen and (max-width: 1300px) {
    width: calc(100vw - 370px);
  }
`

const ReviewsCard = styled.div`
  background: #ffffff;
  height: 300px;
  border: 1px solid #e1e3ea;
  border-radius: 20px;
`

const ReviewsCardText = styled.div`
  margin: 32px 32px 18px 32px;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #21304e;
  height: 188px;
  display: flex;
  align-items: center;
  position: relative;
  padding-top: 30px;

  &:before {
    content: '';
    background: url(${icQuote}) no-repeat;
    background-size: 100%;
    width: 50px;
    height: 33px;
    position: absolute;
    top: 0;
    left: 0;
  }

  &:after {
    content: '';
    background: url(${icQuote}) no-repeat;
    background-size: 100%;
    transform: rotate(180deg);
    width: 50px;
    height: 33px;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  @media (max-width: 1325px) {
    font-size: 18px;
  }
`

const ReviewsAuthor = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #21304e;
  margin-left: 32px;
`

const NpsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 8px 0;
`

const NpsProgressContainer = styled.div`
  margin: 0 52px;
  display: flex;
  overflow: hidden;
`

const NpsProgressItemContainer = styled.div<{ widthPct?: number }>`
  width: ${({ widthPct }) => widthPct ?? 0}%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const NpsProgressItem = styled.div<{ color: string; start?: boolean; end?: boolean }>`
  width: 100%;
  height: 20px;
  background: ${({ color }) => color};
  border-radius: ${({ start, end }) =>
    start ? '10px 0 0 10px' : end ? '0 10px 10px 0' : '0'};
`

const NpsItemLabel = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  color: #3b424f;
  margin-top: 9px;
`

const NpsItemScore = styled(NpsItemLabel)`
  opacity: 0.5;
  margin-top: 2px;
  line-height: 100%;
`

const PushpinContainer = styled.div`
  margin: 0 52px;
`

const NpsPushpin = styled.div<{ progress?: number }>`
  position: relative;
  display: flex;
  width: 46px;
  height: 46px;
  border-radius: 23px;
  background: #c746ff;
  font-weight: 500;
  font-size: 16px;
  color: white;
  align-items: center;
  justify-content: center;
  margin-bottom: 23px;
  margin-left: calc(${({ progress }) => progress ?? 0}% - 23px);

  &:before {
    content: '';
    width: 0px;
    height: 0px;
    border-top: 28px solid #c746ff;
    border-left: 18px solid transparent;
    border-right: 18px solid transparent;
    position: absolute;
    top: 37.5px;
  }
`

const TopDesiredCompaniesArray = [
  { name: 'Siemens', count: 159 },
  { name: 'Deloitte', count: 24 },
  { name: 'Citi', count: 22 },
  { name: 'Klarna', count: 6 },
  { name: 'Google', count: 2 },
  { name: 'BGC', count: 2 },
  { name: 'Amazon', count: 1 },
  { name: 'Morgan Stanley', count: 1 },
]

const PnsProgress = 82

interface IProps {
  showTimeFilter?: boolean
}

const StatisticsComponent = ({ showTimeFilter }: IProps) => {
  const [fromDate, setFromDate] = useState(new Date())
  const [toDate, setToDate] = useState(new Date())
  const [selectedReviewCardIndex, setSelectedReviewCardIndex] = useState(2)

  const renderBlockTitle = (text, icon, iconSize, skipTopPadding: boolean = false) => {
    return (
      <RowContainer top={skipTopPadding ? 0 : 60} bottom={28}>
        <BlockTitleIconContainer>
          <BlockTitleIcon src={icon} alt="icon" size={iconSize} />
        </BlockTitleIconContainer>
        <BlockTitle>{text}</BlockTitle>
      </RowContainer>
    )
  }

  return (
    <Container>
      {showTimeFilter && (
        <RowContainer>
          <FilterLabel>Filter time</FilterLabel>
          <DatePickerWrapper>
            <DatePickerComponent
              value={fromDate}
              label="From date"
              shouldCloseOnSelect
              onChange={setFromDate}
              disableFuture
            />
          </DatePickerWrapper>
          <DatePickerWrapper>
            <DatePickerComponent
              value={toDate}
              label="To date"
              shouldCloseOnSelect
              onChange={setToDate}
              disableFuture
            />
          </DatePickerWrapper>
        </RowContainer>
      )}
      {renderBlockTitle('Key Account Statistics', KeyAccountImg, 20, !showTimeFilter)}
      <RowContainer stretch>
        <ContentBlockContainer widthPct={30} height={200}>
          <CompletedSessionsContainer>
            <BlockTitle>Completed sessions:</BlockTitle>
            <CompletedSessionsValue>549</CompletedSessionsValue>
          </CompletedSessionsContainer>
        </ContentBlockContainer>
        <ContentBlockContainer widthPct={68} height={200}>
          <CompletedSessionsChartContainer>
            <ChartComponent
              color="#F1BE2B"
              value={71}
              title="of job-seekers employed within 90 days of use"
              maxValue={100}
              isPercent
            />
            <ChartComponent
              color="#F23482"
              value={4}
              title="average expert rating"
              maxValue={5}
            />
            <ChartComponent
              color="#6938AA"
              value={100}
              title="of sessions scheduled before the interview date"
              maxValue={100}
              isPercent
            />
            <ChartComponent
              color="#B202FF"
              value={97}
              title="of applicants find the sessions report very helpful"
              maxValue={100}
              isPercent
            />
          </CompletedSessionsChartContainer>
        </ContentBlockContainer>
      </RowContainer>
      {renderBlockTitle('Job Location', LocationImg, 24)}
      <ContentBlockContainer height={380} centered>
        <MapContainer>
          <MapBadge top={73} left={-62} arrowLeft={147}>
            <MapText>North America</MapText>
            <MapValue>3%</MapValue>
          </MapBadge>
          <MapBadge top={63} left={218} arrowLeft={124}>
            <MapText>Europe</MapText>
            <MapValue>{90}%</MapValue>
          </MapBadge>
          <MapBadge top={53} left={429} arrowLeft={93}>
            <MapText>Asia</MapText>
            <MapValue>{2}%</MapValue>
          </MapBadge>
          <MapBadge top={163} left={229} arrowLeft={78}>
            <MapText>Africa & Middle east</MapText>
            <MapValue>{3}%</MapValue>
          </MapBadge>
          <MapBadge top={255} left={24} arrowLeft={152}>
            <MapText>Latin America & Caribbean</MapText>
            <MapValue>{62}%</MapValue>
          </MapBadge>
          <MapBadge top={268} left={451} arrowLeft={52}>
            <MapText>Oceania</MapText>
            <MapValue>{3}%</MapValue>
          </MapBadge>
        </MapContainer>
      </ContentBlockContainer>
      {renderBlockTitle('Top Desired Companies', BagImg, 20)}
      <CompaniesContainer>
        {TopDesiredCompaniesArray.map((item) => (
          <CompanyItemContainer key={item.name} count={item.count}>
            {item.name}
          </CompanyItemContainer>
        ))}
      </CompaniesContainer>
      {renderBlockTitle('NPS', ActivityImg, 20)}
      <ContentBlockContainer height={154}>
        <NpsContainer>
          <PushpinContainer>
            <NpsPushpin progress={(PnsProgress + 100) / 2}>{PnsProgress}%</NpsPushpin>
          </PushpinContainer>
          <NpsProgressContainer>
            <NpsProgressItemContainer widthPct={50}>
              <NpsProgressItem color="#E1E3EA" start />
              <NpsItemLabel>Need improvement</NpsItemLabel>
              <NpsItemScore>-100 - 0</NpsItemScore>
            </NpsProgressItemContainer>
            <NpsProgressItemContainer widthPct={15}>
              <NpsProgressItem color="rgba(178, 2, 255, 0.2)" />
              <NpsItemLabel>Good</NpsItemLabel>
              <NpsItemScore>0 - 30</NpsItemScore>
            </NpsProgressItemContainer>
            <NpsProgressItemContainer widthPct={20}>
              <NpsProgressItem color="#B202FF" />
              <NpsItemLabel>Great</NpsItemLabel>
              <NpsItemScore>30 - 70</NpsItemScore>
            </NpsProgressItemContainer>
            <NpsProgressItemContainer widthPct={15}>
              <NpsProgressItem color="#6938AA" end />
              <NpsItemLabel>Excellent</NpsItemLabel>
              <NpsItemScore>70 - 100</NpsItemScore>
            </NpsProgressItemContainer>
          </NpsProgressContainer>
        </NpsContainer>
      </ContentBlockContainer>
      {renderBlockTitle('Applicants Feedback', LikeImg, 24)}
      <ReviewsBlock>
        <BlockCarousel
          items={Constants.ReviewsItems}
          render={(item) => (
            <ReviewsCard>
              <ReviewsCardText>{item.text}</ReviewsCardText>
              <ReviewsAuthor>{item.author}</ReviewsAuthor>
            </ReviewsCard>
          )}
          paginationTop={26}
          selectedIndex={selectedReviewCardIndex}
          onSelectedIndexChanged={setSelectedReviewCardIndex}
        />
      </ReviewsBlock>
    </Container>
  )
}

export default StatisticsComponent

StatisticsComponent.defaultProps = {
  showTimeFilter: false,
}
